import React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import authFooterStyles from '@/common/components/AuthFooter/AuthFooter.styles';
import { useTranslation } from 'react-i18next';
import { getMarketingSiteUrl } from '@/app/config';
import { useLocale } from '@/common/hooks';
import {
  CONTACT_US_URL,
  PRIVACY_URL,
  TERMS_URL,
} from '@/common/constants/constants';

const AuthFooter = () => {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const legalDisclaimerUrl = getMarketingSiteUrl('/legal-disclaimer', locale);

  return (
    <Box component="footer" sx={authFooterStyles.root}>
      <Link
        href={CONTACT_US_URL}
        sx={authFooterStyles.link}
        rel="noreferrer"
        target="_blank"
      >
        {t('Contact us')}
      </Link>
      <Link
        href={TERMS_URL}
        target="_blank"
        rel="noreferrer"
        sx={authFooterStyles.link}
      >
        {t('Terms & Conditions')}
      </Link>
      <Link
        href={PRIVACY_URL}
        target="_blank"
        rel="noreferrer"
        sx={authFooterStyles.link}
      >
        {t('Privacy policy')}
      </Link>
      <Link
        href={legalDisclaimerUrl}
        target="_blank"
        rel="noreferrer"
        sx={authFooterStyles.link}
      >
        {t('Legal Disclaimer')}
      </Link>
    </Box>
  );
};

export default AuthFooter;
